module.exports = __webpack_public_path__ + "img/shared11.0679b461.png";